import {CountryKeys} from 'shared/lib'

export type ChatUserType = {
  id: string
  name: string
  avatarUrl?: string
  isOnline: boolean
  isBlocked: boolean
  isConfirmed: boolean
  age: number
  isPopular: boolean
  city?: string
  country: CountryKeys
}

type VirtualGiftMessageRequestType = {
  id: number
  text: string | null
  gradient: string | null
}

type PhotoMessageRequestType = {
  key: string
}

type VideoMessageRequestType = {
  cfId: string
}

export type MessageChatRequestReplyType = {
  message: string
  type: 'message' | 'super_match'
}

export type SendMessageRequestType = {text: string} & {reply?: MessageChatRequestReplyType}
  | {id: number} & {reply?: MessageChatRequestReplyType}
  | VirtualGiftMessageRequestType & {reply?: MessageChatRequestReplyType}
  | PhotoMessageRequestType & {reply?: MessageChatRequestReplyType}
  | VideoMessageRequestType & {reply?: MessageChatRequestReplyType}

export enum PhotoTypes {
  attachment = 'attachment',
  avatar = 'avatar',
  VIDEO_AVATAR = 'video-avatar',
  banner = 'banner',
  private = 'private',
  public = 'public',
  showcase = 'showcase'
}

export type BucketPhotoType = {
  key: string
  url: string
}

export type PhotoType = {
  id: string
  type: PhotoTypes
  image: BucketPhotoType
}

export type CfVideoType = {
  cfId: string
  url: string
  iframeUrl: string
  previewUrl: string
  gifUrl: string
  jpgUrl: string
}

export type VirtualGiftType = {
  id: number
  name: string
  price: number
  data: {
    url: string
  }
}